module.exports = __webpack_public_path__ + "media/images/icon_item_activated-0876571940aec3bc990c4f79edfa1930.png";